export default "__VITE_ASSET__DYm$hk1x__"